import React, { Component } from 'react';
import { Modal, PageHeader } from 'react-bootstrap';
import DateTimePicker from 'react-datetime-picker';
import { invokeApig } from '../libs/awsLib';
import './ViewRouteTemperatures.css';
import LoaderButton from '../components/LoaderButton';

/* TODO: rewrite for loops to prevent ESlint errors */
/* eslint-disable guard-for-in, no-restricted-syntax */
export default class ViewRouteTemperatures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertModal: {
        mode: false,
        text: '',
      },
      emails: [],
      isLoading: false,
      routeList: [],
      routeTemperatures: [],
      filteredRouteTemperatures: [],
      startTime: '',
      endTime: '',
      selectedRoute: '',
    };
    this.getRouteTemperatures = this.getRouteTemperatures.bind(this);
    this.queryData = this.queryData.bind(this);
    this.formRouteTemperatures = this.formRouteTemperatures.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  async queryData() {
    console.log(this.state);
    let alertModal;
    if (this.state.startTime === '' || this.state.endTime === '') {
      alertModal = this.state.alertModal;
      alertModal.mode = true;
      alertModal.text = 'Start time or End time cannot be null';
      this.setState({ alertModal });
      return;
    }
    if (this.state.startTime >= this.state.endTime) {
      alertModal = this.state.alertModal;
      alertModal.mode = true;
      alertModal.text = 'Start time cannot be equal or greater than end time';
      this.setState({ alertModal });
      return;
    }
    const startTimeUtc = this.state.startTime.toUTCString();
    const endTimeUtc = this.state.endTime.toUTCString();
    const startTimeEpoch = new Date(startTimeUtc).getTime() / 1000;
    const endTimeEpoch = new Date(endTimeUtc).getTime() / 1000;
    this.getRouteTemperatures(startTimeEpoch, endTimeEpoch);
  }

  compare(a, b) {
    if (a.DateTime > b.DateTime) {
      return 1;
    }
    if (b.DateTime > a.DateTime) {
      return -1;
    }
    return 0;
  }

  async componentDidMount() {
    const endTime = new Date();
    const startTime = new Date();
    startTime.setDate(endTime.getDate() - 1);
    this.setState({ startTime, endTime });
  }

  handleFilterChange(event) {
    this.setState({ [event.target.name]: event.target.value }, () => {
      const filteredRouteTemperatures = [];
      for (const i in this.state.routeTemperatures) {
        let include = true;
        if (
          this.state.selectedRoute === '' ||
          (this.state.selectedRoute !== '' &&
            this.state.routeTemperatures[i].assignedRoute ===
              this.state.selectedRoute)
        ) {
          include = true;
        } else {
          include = false;
        }
        if (include) {
          filteredRouteTemperatures.push(this.state.routeTemperatures[i]);
        }
      }
      this.setState({ filteredRouteTemperatures });
    });
  }

  formRouteTemperatures(temperaturesFromServer) {
    const rows = [];
    for (const record in temperaturesFromServer) {
      const thisDate = new Date(temperaturesFromServer[record].DateTime * 1000);
      const temp = {};
      temp.Location = temperaturesFromServer[record].Location;
      temp.DateTime = `${thisDate.toLocaleDateString(
        'en-US',
      )} ${thisDate.toLocaleTimeString('en-US', { hour12: false })}`;
      temp.Temperature = temperaturesFromServer[record].Temperature;
      temp.assignedRoute = temperaturesFromServer[record].assignedRoute;
      rows.push(temp);
    }
    rows.sort(this.compare);
    this.setState({ routeTemperatures: rows, filteredRouteTemperatures: rows });
  }

  async getRouteTemperatures(startTime, endTime) {
    this.setState({ isLoading: true });
    const resourcePath = `/reports/routetemperatures?startTime=${startTime}&endTime=${endTime}`;
    const routeList = new Set();
    try {
      const response = await invokeApig({
        path: resourcePath,
        method: 'GET',
      });
      const routetemperatures = response.body;
      this.formRouteTemperatures(routetemperatures);
      for (const i in routetemperatures) {
        if ('assignedRoute' in routetemperatures[i]) {
          routeList.add(routetemperatures[i].assignedRoute);
        }
      }
      this.setState({
        isLoading: false,
        routeList: Array.from(routeList).sort(),
        selectedRoute: '',
      });
    } catch (e) {
      console.log(e);
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      // let errorString = JSON.stringify(e);
      // var errorObject = JSON.parse(errorString);
      alertModal.text =
        'Unable to load data, Please check your internet and your permissions';
      this.setState({ alertModal, isLoading: false });
    }
  }

  generateRows(item, key) {
    return (
      <tr
        key={item.Location + item.DateTime}
        className={item.Temperature > 41 ? 'highTemperature' : null}
      >
        <td>{item.Location}</td>
        <td>{item.DateTime}</td>
        <td>{item.Temperature}</td>
        <td>{item.assignedRoute}</td>
      </tr>
    );
  }

  render() {
    return (
      <div>
        <div id="alertBox">
          <Modal show={this.state.alertModal.mode}>
            <Modal.Body>
              <div className="form-group">{this.state.alertModal.text}</div>
            </Modal.Body>
            <Modal.Footer>
              &nbsp;
              <button
                type="button"
                className="btn modalButtons btn-warning"
                onClick={() => {
                  const alertModal = this.state.alertModal;
                  alertModal.mode = false;
                  this.setState({ alertModal });
                }}
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>
        </div>
        <div className="routeTemperatures">
          <PageHeader>Route Temperatures</PageHeader>
          <div className="row">
            <div className="col-sm-5 col-xs-12">
              <font size="5" color="Green">
                Filter From:{' '}
              </font>
              <DateTimePicker
                name="startTimePicker"
                onChange={(date) => this.setState({ startTime: date })}
                value={this.state.startTime}
              />
            </div>
            <div className="col-sm-5 col-xs-12">
              <font size="5" color="Green">
                Filter To:{' '}
              </font>
              <DateTimePicker
                name="endTimePicker"
                onChange={(date) => this.setState({ endTime: date })}
                value={this.state.endTime}
              />
            </div>
            <div className="col-sm-2 col-xs-12">
              <button
                type="button"
                className="btn fetchButton btn-success"
                onClick={this.queryData}
              >
                Fetch Data
              </button>
            </div>
          </div>
          <br />
          {this.state.routeList.length !== 0 && (
            <div className="filterDropDown">
              <div className="col-sm-12 col-xs-12">
                <select
                  name="selectedRoute"
                  value={this.state.selectedRoute}
                  className="form-control"
                  onChange={this.handleFilterChange}
                  selected={this.state.selectedRoute}
                >
                  <option value="">All routes in this time range</option>
                  {Object.keys(this.state.routeList).map((route) => (
                    <option key={route} value={this.state.routeList[route]}>
                      {this.state.routeList[route]}
                    </option>
                  ))}
                </select>
                <br />
              </div>
            </div>
          )}
          {this.state.isLoading && (
            <LoaderButton
              block
              bsStyle="primary"
              bsSize="large"
              disabled=""
              type="submit"
              isLoading={this.state.isLoading}
              text=""
              loadingText="Loading Logs & Users…"
            />
          )}
          {this.state.routeTemperatures.length === 0 && (
            <div className="NotFound">
              <h3>NO Data to Load</h3>
            </div>
          )}
          {this.state.routeTemperatures.length !== 0 && (
            <table id="routeTemperaturesTable">
              <tbody>
                <tr>
                  <th>Location</th>
                  <th>Time</th>
                  <th>Temperature</th>
                  <th>Assigned Route</th>
                </tr>
                {this.state.filteredRouteTemperatures.map(this.generateRows)}
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }
}
